__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/95d5127/_next/";